var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[( _vm.user.role=='ADMIN' )?_c('AdminDashboard'):_vm._e(),( _vm.user.role=='ASSIGNEE' )?_c('AssigneeDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }